// test2332
(2332 && 0);
